<template>
  <div id="portal-payment-header-and-body">
    <div id="portal-payment-header">
      {{ $t("checkout.payment.invoice") }}
    </div>
    <div
      v-if="applicableVoucherAmount > 0"
      class="voucher-section"
    >
      <div
        v-if="voucherBalance"
        class="voucher-balance-strip"
      >
        <strong>
          {{ $t("checkout.payment.voucherBalanceAmounts", {
            remaining: formatUsd(voucherBalance.remaining),
            original: formatUsd(voucherBalance.original)
          }) }}
        </strong>
        - {{ $t("checkout.payment.voucherRemainingBalanceFor", { label: voucherBalance.label }) }}
      </div>
      <div class="form-check voucher-balance-check">
        <input
          id="useVoucherCheckbox"
          v-model="useVoucher"
          class="form-check-input"
          type="checkbox"
        >
        <label
          class="form-check-label"
          for="useVoucherCheckbox"
        >
          {{ $t("checkout.payment.useVoucherBalance") }}
        </label>
      </div>
    </div>
    <div id="portal-payment-body">
      <p class="portal-invoice-text">
        {{ $t("checkout.payment.portalInvoice") }}
      </p>
    </div>
  </div>
</template>
<script>
import { CurrencyApi } from '../../../default/currency_convert'
import { mapMutations } from 'vuex'

export default {
  computed: {
    order() {
      return this.$store.state.order.order
    },
    applicableVoucherAmount(){
      return this.order.applicable_voucher_amount
    },
    voucherBalance(){
      return this.order.voucher_balance
    },
    useVoucher: {
      get(){
        return this.$store.state.checkout.useVoucher
      },
      set(value){
        this.updateUseVoucher(value)
      }
    },
  },
  methods: {
    ...mapMutations('checkout', ['updateUseVoucher']),
    formatUsd(amount){
      return CurrencyApi.formatAmount(amount, 'USD')
    },
  }
}
</script>
